import 'react-datepicker/dist/react-datepicker.css';

import ja from 'date-fns/locale/ja';
import React, { forwardRef } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { FieldRenderProps } from 'react-final-form';
import { Form, FormFieldProps, Input, Label } from 'semantic-ui-react';

interface IProps extends FieldRenderProps<Date, HTMLElement>, FormFieldProps {}

registerLocale('ja', ja);

const CustomInput = forwardRef((props: any, ref) => {
  return <Input {...props} ref={ref} icon='calendar alternate outline' />;
});

const DateInput: React.FC<IProps> = ({
  label,
  input,
  width,
  placeholder,
  disabled,
  readOnly,
  inputOnChange,
  minDate,
  maxDate,
  meta: { touched, error },
}) => {
  return (
    <Form.Field error={touched && !!error} width={width}>
      {label && <label>{label}</label>}
      <DatePicker
        locale='ja'
        dateFormat='yyyy/MM/dd'
        placeholderText={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        selected={input.value || null}
        minDate={minDate}
        maxDate={maxDate}
        onChange={(e) => {
          input.onChange(e);
          inputOnChange && inputOnChange(e);
        }}
        popperPlacement='bottom'
        customInput={<CustomInput />}
      />
      {touched && error && (
        <Label basic color='red'>
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default DateInput;
